import defaultThumnail from "@/public/image/etc/default_thumnail.png"

export default function getThumbnail(li: any) {
    if (li.thumbnail) {
        return li.thumbnail;
    }

    if (li.content) {
        // HTML 문자열에서 img 태그의 src 추출
        const imgMatch = li.content.match(/<img[^>]*src=['"]([^'"]+)['"][^>]*>/i);
        if (imgMatch && imgMatch[1]) {
            return imgMatch[1];
        }
    }

    return defaultThumnail.src;
}